import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function ZapIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="m9.167 1.334-6.667 8h6l-.667 5.333 6.667-8h-6l.667-5.333Z"
      />
    </SvgIcon>
  );
}

export default ZapIcon;
